import { render } from "./modalVentas.vue?vue&type=template&id=16072254"
import script from "./modalVentas.vue?vue&type=script&lang=js"
export * from "./modalVentas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__